import React, {Component} from 'react';
import InfoBlockMiami from '../Theme/Miami/InfoBlockMiami';
class TestMin2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      test: 1
    };
}   

  render() {

    let unit = this.props.screen.r9_16.p10

    return(
         <div style={{height: 1000, width: 1000, backgroundColor: 'green', display: 'flex', alignItems: 'flex-start'}}>
            Hey
            <InfoBlockMiami
            imgsrc="/img/ui/default-user.png"
            imageHeight={unit * 1}
            infoHeight={unit * .5}
            width={unit * 3}
            unit={unit}
            text={"Some text here"}
            infoColor={"red"}
            infoBackgroundColor={'#223954'} 
            fontFamily={'opensans-regular'}
            />
            <InfoBlockMiami
            imgsrc="/img/ui/default-user.png"//{shared.dpath(this.props.mode, this.props.image.path, this.props.image.file_name, this.props.webkey)}
            imageHeight={unit * 1.5}
            infoHeight={unit * 1}
            width={unit * 3}
            unit={unit}
            text={"Some text here that is longer. Maybe goes on two lines I don't know. What about if it is too long well see."}
            infoColor={"white"}
            infoBackgroundColor={'#223954'}
            fontFamily={'opensans-regular'} 
            />
        </div>
        
    )
  }
}

export default TestMin2


// WEBPACK FOOTER //
// ./src/Components/Test/TestMin2.js